module.exports = {
      id: "symbol-info-red-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#symbol-info-red-usage",
      toString: function () {
        return this.url;
      }
    }